const CHART_THEMES = {
  STRONG: "strong-theme",
};

export default { CHART_THEMES };
